import axios from "axios";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContatoType } from "models/contato_type";
import { Draft } from "models/draft_type";
import { EmpresaFilial } from "models/empresa_filial_type";
import { EntregavelItem } from "models/entregavel_itens_type";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import { NotaRodape } from "models/nota_rodape_type";
import { OrderCategory } from "models/order_category";
import { OrderCategoryItem } from "models/order_category_item";
import { OrderItemProduct } from "models/order_item_product";
import { OrderType } from "models/order_type";
import { PessoaType } from "models/person_type";
import { ProductType } from "models/product_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import {
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import XLSX from "sheetjs-style";

import { OrcamentoMidia } from "../../../../models/orcamento_midias_type";
import useDescription from "../description/hooks/useDescription";
import useTemplateOrder from "../item_template/hooks/useTemplateOrder";
import useMeasureUnit from "../measureUnit/hooks/useMeasureUnit";
import useProductOrder from "../product/hooks/useProductOrder";

const useOrder = () => {
  const [show, setShow] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [error, setError] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<OrderType>(null);
  const [list, setList] = useState<OrderType[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<PessoaType[]>();
  const [filteredClients, setFilteredClients] = useState<PessoaType[]>();
  const [agency, setAgency] = useState<PessoaType[]>();
  const [filteredAgency, setFilteredAgency] = useState<PessoaType[]>();
  const [filiais, setFilial] = useState<PessoaType[]>();
  const [selectedClient, setSelectedClient] = useState<PessoaType>();
  const [selectedAgency, setSelectAgency] = useState<PessoaType>();
  const [selectedFilial, setSelectedFilial] = useState<PessoaType>();
  const [condicaoPagamento, setCondicaoPagamento] = useState<
    CondicaoPagamento[]
  >([]);
  const [selectedCondicaoPagamento, setSelectedCondicaoPagamento] =
    useState<CondicaoPagamento>();
  const [modeloNegocio, setModeloNegocio] = useState<ModeloNegocioType[]>([]);
  const [selectedModeloNegocio, setSelectedModeloNegocio] =
    useState<ModeloNegocioType>(null);

  const [entregavel, setEntregavel] = useState<ClientClassificationType[]>([]);
  const [selectedEntregaveis, setSelectedEntregaveis] = useState<
    EntregavelItem[]
  >([]);
  const [midias, setMidias] = useState<ClientClassificationType[]>([]);
  const [selectedMidias, setSelecteMidias] = useState<
    ClientClassificationType[]
  >([]);

  const cancelRef = useRef(null);
  const [totalOrder, setTotalOrder] = useState(0);
  const [totalItens, setTotalItens] = useState(0);
  const [itens, setItens] = useState<OrderCategory[]>([]);
  const [showItem, setShowItem] = useState(false);
  const [showAgenciaInput, setShowAgenciaInput] = useState(true);
  const [data, setData] = useState<Date>(new Date());
  const newDate = new Date();
  const [validade, setValidade] = useState<Date>(
    new Date(newDate.setMonth(newDate.getMonth() + 1))
  );
  const [status, setStatus] = useState("1");
  const [nome, setNome] = useState("");
  const [notas, setNotas] = useState("");
  const [periodoVeiculacao, setPeriodoVeiculacao] = useState("");
  const [footNotes, setFootNotes] = useState<NotaRodape[]>([]);
  const [selectedFootNote, setSelectedFootNotes] = useState<NotaRodape>(null);
  const [notaRodape, setNotaRodape] = useState("");
  const [cadastroDescricaoId, setCadastroDescricaoId] = useState("");
  const [selectedCadastro, setSelectedCadastro] = useState<NotaRodape>(null);
  const [contatoAgencia, setContatoAgencia] = useState("");
  const [emailAgencia, setEmailAgencia] = useState("");
  const [telefoneAgencia, setTelefoneAgencia] = useState("");
  const [listContatoAgencia, setListContatoAgencia] = useState<ContatoType[]>(
    []
  );
  const [contatoCliente, setContatoCliente] = useState("");
  const [emailCliente, setEmailCliente] = useState("");
  const [telefoneCliente, setTelefoneCliente] = useState("");
  const [listContatoCliente, setListContatoCliente] = useState<ContatoType[]>(
    []
  );
  const [descricao, setDescricao] = useState("MONTAR O ITEM PRA TRAZER");
  const [nomeVersao, setNomeVersao] = useState("");
  const [carta, setCarta] = useState("");

  const { unidades } = useMeasureUnit();
  const { produtos } = useProductOrder();
  const nomeRef = useRef(null);

  const [showCadasdastrarMidiaModal, setshowCadasdastrarMidiaModal] =
    useState(false);
  const showMidiaRef = useRef(null);
  const midiaNomeRef = useRef(null);

  const [showCadasdastrarEntregavelModal, setshowCadasdastrarEntregavelModal] =
    useState(false);
  const showEntregavelaRef = useRef(null);
  const entregavelNomeRef = useRef(null);

  const [enableDrag, setEnableDrag] = useState(true);

  const [tipoDesconto, setTipoDesconto] = useState("1");
  const [desconto, setDesconto] = useState(0);
  const [tipoAcrescimo, setTipoAcrescimo] = useState("1");
  const [acrescimo, setAcrescimo] = useState(0);
  const [tipoComissao, setTipoComissao] = useState("1");
  const [comissao, setComissao] = useState(0);
  const [totalCalculado, setTotalCalculado] = useState(0);

  const { templateList } = useTemplateOrder();
  const cancelRascunho = useRef(null);
  const [showRascunho, setShowRascunho] = useState(false);
  const [loadingDraft, setLoadingDraft] = useState(false);
  const [listDraft, setListDraft] = useState<Draft[]>([]);
  const [selectedDraft, setSelectedDraft] = useState<OrderType>(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactPerson, setContactPerson] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [selectedContact, setSelectedContact] = useState<ContatoType>(null);
  const [type, setType] = useState("");
  const cancelAprovacao = useRef(null);
  const [showAprovacao, setShowAprovacao] = useState(false);
  const [loadprovacao, setLoadAprovacao] = useState(false);

  const [itemList, setItemList] = useState<OrderItemProduct[]>([]);

  const showContatoModal = (show: boolean, type: string) => {
    if (!show) {
      setSelectedContact(null);
      setContactPerson("");
      setContactEmail("");
      setContactPhone("");
    }

    if (type === "ag") {
      if (selectedAgency === undefined) {
        showError(
          "Erro!",
          "você deve selecionar uma agência para cadastrar o contato"
        );
      } else {
        setShowContactModal(show);
      }
    } else {
      if (selectedClient === undefined) {
        showError(
          "Erro!",
          "você deve selecionar um cliente para cadastrar o contato"
        );
      } else {
        setShowContactModal(show);
      }
    }
  };
  const validateContact = () => {
    let retorno = true;
    if (contactPerson === "" && contactEmail === "" && contactPhone === "") {
      retorno = false;
    }

    return retorno;
  };
  const showAprovacaoModal = (show: boolean) => {
    if (validate()) {
      if (selectedDraft) {
        showError(
          "Erro!",
          "Não é possível aprovar um orçamento que está como rascunho, salve o mesmo e o aprove."
        );
      } else {
        if (!selectedOrder) {
          showError(
            "Erro!",
            "Não é possível aprovar um orçamento que ainda não está salvo, salve o mesmo e o aprove."
          );
        } else {
          setShowAprovacao(show);
        }
      }
    }
  };

  const changeType = (type: string) => {
    setType(type);
  };

  const insertContact = async (type: string) => {
    const personId = type === "ag" ? selectedAgency.id : selectedClient.id;
    const addItem: ContatoType = {
      ativo: true,
      cargo: "",
      email: contactEmail,
      nome: contactPerson,
      idPessoa: personId,
      principal: false,
      telefone: contactPhone,
      id: "",
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/contato/create",
      addItem
    );
    if (response.data) {
      const returnedItem: ContatoType = response.data;
      if (type === "ag") {
        await loadAgency();
        const newList = listContatoAgencia;
        newList.push(returnedItem);
        setListContatoAgencia(newList);

        changeInput("contatoAgencia", returnedItem?.id);
        changeInput("emailAgencia", returnedItem?.email);
        changeInput("telefoneAgencia", returnedItem?.telefone);
      } else {
        await loadClient();
        const newList = listContatoCliente;
        newList.push(returnedItem);
        setListContatoCliente(newList);
        changeInput("contatoCliente", returnedItem?.id);
        changeInput("emailCliente", returnedItem?.email);
        changeInput("telefoneCliente", returnedItem?.telefone);
      }
    }
  };

  const updateContact = async (type: string) => {
    const addItem: ContatoType = {
      ativo: true,
      cargo: "",
      email: contactEmail ?? selectedContact.email,
      nome: contactPerson ?? selectedContact.nome,
      idPessoa: selectedContact.idPessoa,
      principal: false,
      telefone: contactPhone ?? selectedContact.telefone,
      id: selectedContact.id,
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/contato/update",
      addItem
    );
    if (response.data !== null) {
      const returnedItem: ContatoType = response.data;
      if (type === "ag") {
        await loadAgency();
        const newList = listContatoAgencia.map((existingItem) => {
          if (existingItem.id === returnedItem.id) {
            return returnedItem;
          }
          return existingItem;
        });

        setListContatoAgencia(newList);
        changeInput("emailAgencia", returnedItem?.email);
        changeInput("telefoneAgencia", returnedItem?.telefone);
      } else {
        await loadClient();
        const newList = listContatoCliente.map((existingItem) => {
          if (existingItem.id === returnedItem.id) {
            return returnedItem;
          }
          return existingItem;
        });

        setListContatoCliente(newList);
        changeInput("emailCliente", returnedItem?.email);
        changeInput("telefoneCliente", returnedItem?.telefone);
      }
    }
  };

  const saveContact = async (type: string, action: string) => {
    if (validateContact()) {
      if (type === "ag") {
        if (action === "insert") {
          await insertContact(type);
        } else {
          await updateContact(type);
        }
      } else {
        if (action === "insert") {
          await insertContact(type);
        } else {
          await updateContact(type);
        }
      }
      showContatoModal(false, type);
      setContactPerson("");
      setContactEmail("");
      setContactPhone("");
    } else {
      showError(
        "Erro!",
        "Preencha ao menos um contato, seja o responsável, telefone ou email"
      );
    }
  };

  const editContact = (type: string) => {
    if (type === "ag") {
      const sa = listContatoAgencia.find((item) => item.id === contatoAgencia);
      setSelectedContact(sa);
    } else {
      const cl = listContatoCliente.find((item) => item.id === contatoCliente);
      setSelectedContact(cl);
    }
    showContatoModal(true, type);
  };

  const showDraft = (show: boolean) => {
    setShowRascunho(show);
  };
  const cancelSaveDraft = () => {
    setShowRascunho(false);
    setError(false);
    cleanInput();
    setShow(false);
    setSelectedDraft(null);
    setLoadingDraft(false);
  };

  const saveDraft = async () => {
    if (selectedDraft) {
      await updateDraft();
    } else {
      await insertDraft();
    }
  };

  const updateDraft = async () => {
    setLoadingDraft(true);

    const draftMidia: OrcamentoMidia[] = [];
    if (selectedMidias?.length > 0) {
      selectedMidias?.forEach((m) => {
        draftMidia.push({
          id: "",
          midiasId: m.id,
          orcamentoId: 0,
        });
      });
    }
    const draft: any = {
      acrescimo: Number(acrescimo),
      agenciaId: selectedAgency?.id ?? null,
      clientId: selectedClient?.id,
      comissao: Number(comissao),
      condicaoPagamentoId: selectedCondicaoPagamento?.id,
      contatoAgencia: contatoAgencia,
      contatoAgenciaEmail: emailAgencia,
      contatoAgenciaTelefone: telefoneAgencia,
      data: data,
      empresaSaiadaId: selectedFilial?.id,
      desconto: desconto,
      descricao: descricao,
      carta: carta !== "" ? carta : footNotes[0]?.descricao,
      notaRodapeId: selectedFootNote?.id ?? null,
      notaRodapeTexto: notaRodape,
      contatoCliente: contatoCliente,
      contatoClienteEmail: emailCliente,
      contatoClienteTelefone: telefoneCliente,
      usuarioId: usuario.id,
      notas: notas,
      modeloNegocioId: selectedModeloNegocio?.id,
      showAgencia: showAgenciaInput,
      idEmpresa: usuario?.idEmpresa,
      status: "0",
      validade: validade,
      periodoVeiculacao: periodoVeiculacao,
      total: totalOrder,
      versao: 1,
      nome: nome,
      nomeVersao: nomeVersao,
      tipoDesconto: tipoDesconto,
      tipoComissao: tipoComissao,
      tipoAcrescimo: tipoAcrescimo,
      OrcamentoCategoria: itens,
      EntregavelItens: selectedEntregaveis,
      OrcamentoMidias: draftMidia,
      agencia: selectedAgency,
      cliente: selectedClient,
      condicaoPagamento: selectedCondicaoPagamento,
      empresaSaida: selectedFilial,
      modeloNegocio: selectedModeloNegocio,
      Usuario: usuario,
    };
    const draftData = JSON.stringify(draft);

    const addDraft = {
      id: selectedDraft.id,
      usuarioId: usuario.id,
      rascunho: draftData,
    };
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/rascunho-orcamento/" + selectedDraft.id,
      addDraft
    );
    if (response.data) {
      cancelSaveDraft();
      setTimeout(async () => {
        await loadOrder();
        await loadDraft();
      }, 1000);
    }
  };

  const insertDraft = async () => {
    setLoadingDraft(true);

    const draftMidia: OrcamentoMidia[] = [];
    if (selectedMidias?.length > 0) {
      selectedMidias?.forEach((m) => {
        draftMidia.push({
          id: "",
          midiasId: m.id,
          orcamentoId: 0,
        });
      });
    }
    const draft: any = {
      acrescimo: Number(acrescimo),
      agenciaId: selectedAgency?.id ?? null,
      clientId: selectedClient?.id,
      comissao: Number(comissao),
      condicaoPagamentoId: selectedCondicaoPagamento?.id,
      contatoAgencia: contatoAgencia,
      contatoAgenciaEmail: emailAgencia,
      contatoAgenciaTelefone: telefoneAgencia,
      data: data,
      empresaSaiadaId: selectedFilial?.id,
      desconto: desconto,
      descricao: descricao,
      carta: carta !== "" ? carta : footNotes[0]?.descricao,
      notaRodapeId: selectedFootNote?.id ?? null,
      notaRodapeTexto: notaRodape,
      contatoCliente: contatoCliente,
      contatoClienteEmail: emailCliente,
      contatoClienteTelefone: telefoneCliente,
      usuarioId: usuario.id,
      notas: notas,
      modeloNegocioId: selectedModeloNegocio?.id,
      showAgencia: showAgenciaInput,
      idEmpresa: usuario?.idEmpresa,
      status: "0",
      validade: validade,
      periodoVeiculacao: periodoVeiculacao,
      total: totalOrder,
      versao: 1,
      nome: nome,
      nomeVersao: nomeVersao,
      tipoDesconto: tipoDesconto,
      tipoComissao: tipoComissao,
      tipoAcrescimo: tipoAcrescimo,
      OrcamentoCategoria: itens,
      EntregavelItens: selectedEntregaveis,
      OrcamentoMidias: draftMidia,
      agencia: selectedAgency,
      cliente: selectedClient,
      condicaoPagamento: selectedCondicaoPagamento,
      empresaSaida: selectedFilial,
      modeloNegocio: selectedModeloNegocio,
      Usuario: usuario,
      cadastroDescricaoId: cadastroDescricaoId,
    };
    const draftData = JSON.stringify(draft);

    const addDraft = {
      usuarioId: usuario.id,
      rascunho: draftData,
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/rascunho-orcamento/",
      addDraft
    );
    if (response.data) {
      cancelSaveDraft();
      setTimeout(async () => {
        await loadOrder();
        await loadDraft();
      }, 1000);
    }
  };

  const editDraft = (item: OrderType) => {
    setSelectedDraft(item);
    edit(item);
  };

  const changeFootNotes = (value: string) => {
    const find = footNotes.find((idt) => idt.id === value);
    setSelectedFootNotes(find);
    setNotaRodape(value);
  };

  const changeCadastroDescricao = (value: string) => {
    const find = descricoes.find((idt) => idt.id === value);
    setSelectedCadastro(find);
    setCadastroDescricaoId(value);
  };
  const cleanInput = () => {
    setTipoDesconto("1");
    setTipoAcrescimo("1");
    setTipoComissao("1");
    setSelectAgency(null);
    setSelecteMidias([]);
    setSelectedClient(null);
    setNome(null);
    setSelectedCondicaoPagamento(null);
    setStatus("1");
    setSelectedFilial(null);
    setEmailAgencia("");
    setTelefoneAgencia("");
    setContatoAgencia("");
    setItens([]);
    setSelectedOrder(null);
    setSelectedModeloNegocio(null);
    setSelectedEntregaveis(null);
    setSelecteMidias(null);
    setTotalItens(0);
    setTotalOrder(0);
    setTotalCalculado(0);
    setData(new Date());
    setValidade(newDate);
    setNotas(null);
    setPeriodoVeiculacao("");
    setSelectedFootNotes(null);
    setNomeVersao("");
    setNotaRodape("");
    setAcrescimo(0);
    setComissao(0);
    setListContatoAgencia([]);
    setContatoCliente("");
    setEmailCliente("");
    setTelefoneCliente("");
    setListContatoCliente(null);
    setDescricao("");
    setCarta("");
    setPeriodoVeiculacao("");
  };
  const exportExcel = async () => {
    const fileExtension = ".xlsx";
    //const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileName = `${nome}-${selectedClient?.nome}-${selectedAgency?.nome}-${
      selectedOrder?.id
    }-1-${moment().format("YYYY-MM-DD")}`;
    const ws = XLSX.utils.json_to_sheet(createItemSpreadSheet());
    const ws1 = XLSX.utils.json_to_sheet(createCalcSpreadSheet());
    const ws0 = XLSX.utils.json_to_sheet(createHeaderSpreadSheet());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws0, "Cabeçalho");
    XLSX.utils.book_append_sheet(workbook, ws, "Itens do Orçamento");
    XLSX.utils.book_append_sheet(workbook, ws1, "Cálculo do Orçamento");
    XLSX.writeFile(workbook, fileName + fileExtension, { compression: true });
  };

  const changeCarta = (carta: string) => {
    setCarta(carta);
  };

  const createItemSpreadSheet = () => {
    const contentList: any[] = [];
    itens?.forEach((item) => {
      item.OrcamentoItem.forEach((value) => {
        const it = {
          CATEGORIA: item.descricao,
          ITEM: value.produtoNome,
          DESCRIÇÃO: value.descricao,
          "UNIDADE MEDIDA": value.unidadeNome,
          "VALOR UNITÁRIO": value.valorUn,
          "VALOR TOTAL ITEM": value.valorTotal,
        };
        contentList.push(it);
      });
    });
    return contentList;
  };

  const createCalcSpreadSheet = () => {
    const contentList: any[] = [];
    const custofixo = (selectedModeloNegocio.custoFixo * totalOrder) / 100;
    const custovenda = (selectedModeloNegocio.custoVenda * totalOrder) / 100;
    const totalcustoproduto = custofixo + custovenda + totalOrder;
    const lucrovalor =
      (selectedModeloNegocio.metaLucro * totalcustoproduto) / 100;
    const custoprodutolucro = totalcustoproduto + lucrovalor;
    const custoprodutoliquido =
      custoprodutolucro + comissao + acrescimo - desconto;
    const valorImposto =
      (custoprodutoliquido / (100 - selectedModeloNegocio.imposto)) * 100 -
      custoprodutoliquido;
    const calculaTotal = custoprodutoliquido + valorImposto;
    const itemValor = {
      "MODELO DE NEGÓCIO": selectedModeloNegocio?.nome,
      "TOTAL CUSTO PRODUÇÃO": totalItens,
      "CUSTOS FIXOS - PORCENTAGEM": `(${
        selectedModeloNegocio?.custoFixo / 100
      }) %`,
      "CUSTOS FIXOS - VALOR": custofixo,
      "CUSTOS DE VENDA - PORCENTAGEM": `(${
        selectedModeloNegocio?.custoVenda / 100
      }) %`,
      "CUSTOS DE VENDA - VALOR": custovenda,
      "TOTAL CUSTO PRODUTO - VALOR": totalcustoproduto,
      "LUCRO - PORCENTAGEM": `(${selectedModeloNegocio?.metaLucro / 100}) %`,
      "LUCRO - VALOR": lucrovalor,
      "DESCONTO - PORCENTAGEM": `(${selectedModeloNegocio?.desconto / 100}) %`,
      "DESCONTO - VALOR": desconto,
      ACRESCIMO: acrescimo,
      "COMISSAO ADICIONAL": comissao,
      "TOTAL DO PREÇO LIQUIDO": custoprodutoliquido,
      "IMPOSTOS - PORCENTAGEM": `(${selectedModeloNegocio?.imposto / 100}) %`,
      "VALOR DOS IMPOSTOS": valorImposto,
      "TOTAL DO ORÇAMENTO": calculaTotal,
    };

    contentList.push(itemValor);

    return contentList;
  };

  const createHeaderSpreadSheet = () => {
    const contentList: any[] = [];

    const item = {
      DATA: data,
      RESPONSAVEL: usuario?.nome,
      PROJETO: nome,
      EMPRESA: selectedFilial?.nome,
      AGENCIA: selectedAgency?.nome,
      CLIENTE: selectedClient?.nome,
      "MODELO NEGÓCIO": selectedModeloNegocio?.nome,
      "CONDIÇÃO PAGAMENTO": selectedCondicaoPagamento?.nome,
      "VALIDADE DA PROPOSTA": validade,
    };

    contentList.push(item);

    return contentList;
  };

  const isDragable = (drag: boolean) => {
    setEnableDrag(drag);
  };

  const stateSetterMap: any = {
    data: setData,
    nome: setNome,
    status: setStatus,
    notas: setNotas,
    showAgencia: setShowAgenciaInput,
    validade: setValidade,
    periodoVeiculacao: setPeriodoVeiculacao,
    tipoAcrescimo: setTipoAcrescimo,
    acrescimo: (value: string) => setAcrescimo(Number(value)),
    tipoComissao: setTipoComissao,
    comissao: (value: string) => setComissao(Number(value)),
    contatoAgencia: setContatoAgencia,
    emailAgencia: setEmailAgencia,
    telefoneAgencia: setTelefoneAgencia,
    contatoCliente: setContatoCliente,
    emailCliente: setEmailCliente,
    telefoneCliente: setTelefoneCliente,
    descricao: setDescricao,
    notasRodape: setNotaRodape,
    cadastroDecricao: setCadastroDescricaoId,
    tipoDesconto: setTipoDesconto,
    desconto: (value: string) => setDesconto(Number(value)),
    totalCalculado: (value: string) => setTotalCalculado(Number(value)),
    nomeVersao: setNomeVersao,
    contactPerson: setContactPerson,
    contactEmail: setContactEmail,
    contactPhone: setContactPhone,
  };

  const changeInput = (tipo: string, value: any) => {
    const setter = stateSetterMap[tipo];
    if (setter) {
      setter(value);
    }
  };

  const showItemModal = (show: boolean) => {
    setShowItem(show);
  };

  const showAgenciaInputModal = (show: boolean) => {
    setShowAgenciaInput(show);
  };

  const saveCategory = () => {
    if (nomeRef.current.value !== null) {
      const categArray = itens;

      const add: OrderCategory = {
        descricao: nomeRef.current,
        OrcamentoItem: [],
        orcamentoId: 0,
        valor: 0.0,
        id: "",
        OrcamentoProduto: [],
      };
      const exists = categArray.find(
        (value) => value.descricao === add.descricao
      );
      if (!exists) {
        categArray.push(add);
        setShowItem(false);
      }
    }
  };

  const changeItem = (item: OrderCategory) => {
    let total = 0;
    let newItems: OrderCategory[] = [];

    if (itens?.length > 0) {
      newItems = itens.map((existingItem) => {
        if (existingItem.descricao === item.descricao) {
          return item;
        }
        return existingItem;
      });
    }

    newItems.forEach((value) => {
      let itemTotal = 0;
      if (value?.OrcamentoItem?.length > 0) {
        itemTotal = value?.OrcamentoItem?.reduce(
          (acc, vl) => acc + Number(vl.valorTotal),
          0
        );
      }
      if (value?.OrcamentoProduto?.length > 0) {
        itemTotal += value?.OrcamentoProduto?.reduce(
          (acc, vt) => acc + Number(vt.valorTotal),
          0
        );
      }
      value.valor = itemTotal;
      total = total + itemTotal;
    });

    calculaTotalOrder(total);
    setTotalItens(total);
    setItens(newItems);
  };

  const removeItem = (item: OrderCategory) => {
    let total = 0;
    const list = itens;
    const data = list.filter((data) => data !== item);
    data.forEach((item) => {
      total = total + item.valor;
    });

    calculaTotalOrder(total);
    setTotalItens(total);
    setItens(data);
  };

  const add = () => {
    setShow(true);
  };

  const showModal = (show: boolean) => {
    if (!show) {
      if (selectedOrder) {
        if (selectedOrder.status === "0") {
          showDraft(true);
        } else {
          cancelSaveDraft();
        }
      } else {
        showDraft(true);
      }
    } else {
      setShow(true);
    }
  };
  const showPrintModal = (show: boolean) => {
    setShowPrint(show);
    if (!show) {
    }
  };

  const showDeleteModal = (item: OrderType) => {
    setShowDelete(true);
    setSelectedOrder(item);
  };

  const print = (item: OrderType) => {
    setSelectedOrder(item);
    setShowPrint(true);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const closeError = () => {
    setError(false);
  };

  const onChangeClient = (client: string) => {
    const cItem = clients?.find((item) => item.id === client);
    const contatoList: SetStateAction<ContatoType[]> = [];
    if (cItem?.Contato?.length > 0) {
      cItem?.Contato?.forEach((contato) => {
        contatoList.push(contato);
      });
    }
    setTelefoneCliente(contatoList[0]?.telefone ?? "");
    setEmailCliente(contatoList[0]?.email ?? "");
    setContatoCliente(contatoList[0]?.id ?? "");
    setListContatoCliente(contatoList);
    setSelectedClient(cItem);
  };

  const onChangeAgency = (ag: string) => {
    const aItem = agency.find((item) => item.id === ag);
    const contatoList: SetStateAction<ContatoType[]> = [];
    if (aItem.Contato.length > 0) {
      aItem?.Contato?.forEach((contato) => {
        contatoList.push(contato);
      });
    }
    setTelefoneAgencia(contatoList[0]?.telefone ?? "");
    setEmailAgencia(contatoList[0]?.email ?? "");
    setContatoAgencia(contatoList[0]?.id ?? "");
    setListContatoAgencia(contatoList);
    setSelectAgency(aItem);
  };

  const onChangeMidias = (midia: any[]) => {
    const list: ClientClassificationType[] = [];
    midia?.forEach((val) => {
      const existe = selectedMidias?.find((valor) => valor.id === val?.value);
      if (!existe) {
        const item: ClientClassificationType = {
          idEmpresa: usuario.idEmpresa,
          nome: val?.label,
          id: val?.value,
        };

        list.push(item);
      } else {
        list.push(existe);
      }
    });
    setSelecteMidias(list);
  };

  const onChangeEntregavel = (et: any[]) => {
    setSelectedEntregaveis(et);
  };

  const onChangeFilial = useCallback(
    async (fl: string) => {
      if (fl !== "0") {
        const resposta = await loadPessoaFilial(fl);
        const pessoaFilial: EmpresaFilial[] = resposta;
        const listString: string[] = pessoaFilial.map((pf) => pf.idPessoa);

        const filterFunction = (list: PessoaType[]) =>
          list.filter((client) => listString.includes(client.id));
        const selectedFilial = filiais.find((item) => item.id === fl);

        setSelectedFilial(selectedFilial);
        setFilteredClients(filterFunction(clients));
        setFilteredAgency(filterFunction(agency));
      } else {
        setSelectedFilial(null);
        cleanDataInputs();
        setFilteredClients(clients);
        setFilteredAgency(agency);
      }
    },
    [agency, clients, filiais]
  );

  const cleanDataInputs = () => {
    setSelectedClient(null);
    setSelectAgency(null);
    setListContatoAgencia(null);
    setListContatoCliente(null);
    setContatoCliente(null);
    setContatoAgencia(null);
    setTelefoneAgencia(null);
    setTelefoneCliente(null);
    setEmailAgencia(null);
    setEmailCliente(null);
  };
  const onChangePagamento = (pg: string) => {
    const pItem = condicaoPagamento.find((item) => item.id === pg);
    setSelectedCondicaoPagamento(pItem);
  };

  const onChangeModeloNegocio = (mn: string) => {
    const selectedModeloNegocio = modeloNegocio.find((item) => item.id === mn);

    const total = itens.reduce((acc, item) => acc + Number(item.valor), 0);

    setSelectedModeloNegocio(selectedModeloNegocio);
    calculaTotalOrder(total);
    setTotalItens(total);
  };

  const loadOrder = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setList(response.data);
    }
  };

  const loadClient = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/clients/" + userData?.idEmpresa
    );
    if (response.data) {
      setClients(response.data);
      setFilteredClients(response.data);

      const newArray: PessoaType[] = response.data;
      setClients(response.data);
      setFilteredClients(response.data);
      if (selectedClient) {
        const newItem = newArray.find((item) => item.id === selectedClient.id);

        setSelectedClient(newItem);
        onChangeClient(newItem.id);
      }
    }
  };

  const loadPessoaFilial = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/filial-pessoa/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      return response.data;
    }
  };

  const loadAgency = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/agency/" + userData?.idEmpresa
    );
    if (response.data) {
      const newArray: PessoaType[] = response.data;
      setAgency(response.data);
      setFilteredAgency(response.data);
      if (selectedAgency) {
        const newItem = newArray.find((item) => item.id === selectedAgency.id);
        setSelectAgency(newItem);
        onChangeAgency(newItem.id);
      }
    }
  };

  const loadCondicaoPagamento = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamento(response.data);
    }
  };

  const loadModeloNegocio = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/modelo-negocio/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setModeloNegocio(response.data);
    }
  };

  const loadEmpresas = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFilial(response.data);
    }
  };

  const remove = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/orcamento/" + selectedOrder?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setSelectedOrder(null);
      setShowDelete(false);
      await loadOrder();
      await loadDraft();
    }
  };

  const removeDraft = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/rascunho-orcamento/" + selectedDraft?.id
    );
    if (response.data) {
      cancelSaveDraft();
      setSelectedOrder(null);
      setShowDelete(false);
      setSelectedDraft(null);
      await loadDraft();
      await loadOrder();
    }
  };

  const deletar = (item: OrderType) => {
    setShowDelete(true);
    setSelectedOrder(item);
  };

  const deleteDraft = (item: OrderType) => {
    setShowDelete(true);
    setSelectedDraft(item);
  };

  const mapMidias = (OrcamentoMidias: any[], midias: any[]) => {
    const md: { id: any; idEmpresa: string; nome: any }[] = [];
    if (OrcamentoMidias?.length > 0) {
      OrcamentoMidias.forEach((midia) => {
        const toAdd = {
          id: midia.midiasId,
          idEmpresa: usuario.idEmpresa,
          nome: midias?.find((val) => val.id === midia.midiasId)?.nome,
        };
        md.push(toAdd);
      });
    }
    return md;
  };

  const mapOrcamentoCategoria = (
    OrcamentoCategoria: any[],
    produtos: ProductType[],
    unidades: ClientClassificationType[]
  ) => {
    const newItens: {
      descricao: any;
      orcamentoId: any;
      valor: any;
      id: any;
      OrcamentoItem: any[];
      OrcamentoProduto: {
        descricao: any;
        id: any;
        orcamentoCategoriaId: any;
        NovoProduto: any;
        novoProdutoId: any;
        quantidade: any;
        valorTotal: any;
        valorUn: any;
      }[];
    }[] = [];
    if (OrcamentoCategoria?.length > 0) {
      OrcamentoCategoria.forEach((valor) => {
        const dt = mapOrcamentoItem(valor.OrcamentoItem, produtos, unidades);
        const it = mapOrcamentoProduto(valor.OrcamentoProduto);
        const cat = {
          descricao: valor.descricao,
          orcamentoId: valor.orcamentoId,
          valor: valor.valor,
          id: valor.id,
          OrcamentoItem: dt,
          OrcamentoProduto: it,
        };
        newItens.push(cat);
      });
    }
    return newItens;
  };

  const mapOrcamentoItem = (
    OrcamentoItem: any[],
    produtos: any[],
    unidades: any[]
  ) => {
    const dt: {
      descricao: any;
      id: any;
      produtoId: any;
      orcamentoCategoriaId: any;
      produtoNome: any;
      produtoUnidade: any;
      produtoUnidadeId: any;
      quantidade: any;
      unidadeMedidaId: any;
      unidadeNome: any;
      validade: any;
      valorTotal: any;
      valorUn: any;
    }[] = [];
    if (OrcamentoItem?.length > 0) {
      OrcamentoItem.forEach((oi) => {
        const itemPrd = produtos.find((prd) => prd.id === oi.produtoId);
        const itemUn = unidades.find((un) => un.id === oi.unidadeMedidaId);
        const add = {
          descricao: oi.descricao,
          id: oi.id,
          produtoId: oi.produtoId,
          orcamentoCategoriaId: oi.orcamentoCategoriaId,
          produtoNome: itemPrd?.nome,
          produtoUnidade: itemPrd?.ProdutoUnidade,
          produtoUnidadeId: oi.produtoUnidadeId,
          quantidade: oi.quantidade,
          unidadeMedidaId: oi.unidadeMedidaId,
          unidadeNome: itemUn?.nome,
          validade: oi.validade,
          valorTotal: oi.valorTotal,
          valorUn: oi.valorUn,
        };
        dt.push(add);
      });
    }
    return dt;
  };

  const mapOrcamentoProduto = (OrcamentoProduto: any[]) => {
    const it: {
      descricao: any;
      id: any;
      orcamentoCategoriaId: any;
      NovoProduto: any;
      novoProdutoId: any;
      quantidade: any;
      valorTotal: any;
      valorUn: any;
    }[] = [];
    if (OrcamentoProduto?.length > 0) {
      OrcamentoProduto.forEach((at) => {
        const addItem = {
          descricao: at.descricao,
          id: at.id,
          orcamentoCategoriaId: at.orcamentoCategoriaId,
          NovoProduto: at.NovoProduto,
          novoProdutoId: at.novoProdutoId,
          quantidade: at.quantidade,
          valorTotal: at.valorTotal,
          valorUn: at.valorUn,
        };
        it.push(addItem);
      });
    }
    return it;
  };

  const edit = (item: OrderType) => {
    setSelectedClient(item?.cliente);
    setSelectAgency(item?.agencia);

    calculaTotalOrder(Number(item?.total));
    setSelectedOrder(item);
    setData(new Date(item?.data));
    setValidade(new Date(item?.validade));
    setSelectedModeloNegocio(item?.modeloNegocio);
    setSelectedCondicaoPagamento(item?.condicaoPagamento);
    setDesconto(Number(item?.desconto));
    setAcrescimo(Number(item?.acrescimo));
    setComissao(Number(item?.comissao));
    setCadastroDescricaoId(item?.cadastroDescricaoId);
    setShowAgenciaInput(item?.showAgencia);
    setSelectedEntregaveis(item?.EntregavelItens);
    setSelecteMidias(mapMidias(item?.OrcamentoMidias, midias));
    setItens(
      mapOrcamentoCategoria(item?.OrcamentoCategoria, produtos, unidades)
    );
    setNomeVersao(item?.nomeVersao);
    setTotalItens(Number(item.total));

    changeFootNotes(item?.notaRodapeId);
    setEmailAgencia(item?.contatoAgenciaEmail);
    setEmailCliente(item?.contatoClienteEmail);
    setTelefoneAgencia(item?.contatoAgenciaTelefone);
    setTelefoneCliente(item?.contatoClienteTelefone);
    setContatoAgencia(item?.contatoAgencia);
    setContatoCliente(item?.contatoCliente);
    setListContatoCliente(item?.cliente?.Contato);
    setListContatoAgencia(item?.agencia?.Contato);
    setNotas(item?.notas);
    setPeriodoVeiculacao(item?.periodoVeiculacao);
    onChangeClient(item?.clientId);
    setNome(item?.nome);
    setSelectedFilial(item?.empresaSaida);
    setStatus(item?.status);
    setNotaRodape(item?.notaRodapeTexto);
    setTipoAcrescimo(item?.tipoAcrescimo);
    setTipoComissao(item?.tipoComissao);
    setTipoDesconto(item?.tipoDesconto);
    setDescricao(item?.descricao);

    setShow(true);
  };

  const onChangeTemplate = (item: string) => {
    if (item !== "0") {
      const filter = templateList.find((a) => a.id === item);
      if (filter) {
        const newItens: OrderCategory[] = [];

        if (filter.ModeloOrcamentoItemCategoria.length > 0) {
          filter.ModeloOrcamentoItemCategoria.forEach((valor) => {
            const dt: OrderCategoryItem[] = [];
            const it: OrderItemProduct[] = [];
            if (valor?.ModeloOrcamentoItemList?.length > 0) {
              valor.ModeloOrcamentoItemList.forEach((oi) => {
                const itemPrd = produtos.find((prd) => prd.id === oi.produtoId);
                const itemUn = unidades.find(
                  (un) => un.id === oi.unidadeMedidaId
                );
                const add: OrderCategoryItem = {
                  descricao: oi.descricao,
                  id: oi.id,
                  produtoId: oi.produtoId,
                  orcamentoCategoriaId: oi.modeloOrcamentoItemCategoriaId,
                  produtoNome: itemPrd?.nome,
                  produtoUnidade: itemPrd?.ProdutoUnidade,
                  produtoUnidadeId: oi.produtoUnidadeId,
                  quantidade: oi.quantidade,
                  unidadeMedidaId: oi.unidadeMedidaId,
                  unidadeNome: itemUn?.nome,
                  validade: oi.validade,
                  valorTotal: oi.valorTotal,
                  valorUn: oi.valorUn,
                };
                dt.push(add);
              });
            }
            if (valor?.ModeloOrcamentoItemProdutoList?.length > 0) {
              valor?.ModeloOrcamentoItemProdutoList.forEach((at) => {
                const addItem: OrderItemProduct = {
                  descricao: at.descricao,
                  id: at.id,
                  orcamentoCategoriaId: at.modeloOrcamentoItemCategoriaId,
                  NovoProduto: at.NovoProduto,
                  novoProdutoId: at.novoProdutoId,
                  quantidade: at.quantidade,
                  valorTotal: at.valorTotal,
                  valorUn: at.valorUn,
                };
                it.push(addItem);
              });
            }
            const cat: OrderCategory = {
              descricao: valor.descricao,
              orcamentoId: 0,
              valor: valor.valor,
              id: valor.id,
              OrcamentoItem: dt,
              OrcamentoProduto: it,
            };
            newItens.push(cat);
          });
          let total = 0;
          newItens.forEach((item) => {
            total = total + Number(item.valor);
          });

          setItens(newItens);
          calculaTotalOrder(Number(total));
          setTotalItens(Number(total));
        }
      }
    }
  };

  const saveAprovacao = async () => {
    setLoadAprovacao(true);
    setLoading(true);
    const updateOrder = {
      id: selectedOrder.id,
      acrescimo: Number(acrescimo),
      agenciaId: selectedAgency?.id ?? null,
      clientId: selectedClient?.id,
      comissao: Number(comissao),
      condicaoPagamentoId: selectedCondicaoPagamento?.id,
      contatoAgencia: contatoAgencia,
      contatoAgenciaEmail: emailAgencia,
      contatoAgenciaTelefone: telefoneAgencia,
      data: data,
      empresaSaiadaId: selectedFilial.id,
      desconto: desconto,
      descricao: descricao,
      carta: carta !== "" ? carta : footNotes[0]?.descricao,
      notaRodapeId: selectedFootNote?.id ?? null,
      notaRodapeTexto: notaRodape,
      contatoCliente: contatoCliente,
      contatoClienteEmail: emailCliente,
      contatoClienteTelefone: telefoneCliente,
      usuarioId: usuario.id,
      notas: notas,
      modeloNegocioId: selectedModeloNegocio.id,
      showAgencia: showAgenciaInput,
      idEmpresa: usuario.idEmpresa,
      status: "3",
      validade: validade,
      periodoVeiculacao: periodoVeiculacao,
      total: totalOrder,
      versao: selectedOrder.versao + 1,
      nome: nome,
      tipoDesconto: tipoDesconto,
      tipoComissao: tipoComissao,
      tipoAcrescimo: tipoAcrescimo,
      nomeVersao: nomeVersao,
      cadastroDescricaoId: cadastroDescricaoId,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/orcamento/" + selectedOrder.id,
      updateOrder
    );
    if (response.data) {
      const id = selectedOrder.id;

      if (itens?.length > 0) {
        const removeCateg = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/category/" + Number(id)
        );
        if (removeCateg.data === true) {
          itens?.forEach(async (item) => {
            if (item.id !== "") {
              await axios.delete(
                process.env.REACT_APP_API_URL + "/orcamento/itens/" + item.id
              );
            }

            const addCategory = {
              orcamentoId: id,
              descricao: item.descricao,
              valor: item.valor,
            };
            const categ = await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/category/",
              addCategory
            );
            if (categ.data) {
              const categId = categ.data;
              if (item.OrcamentoItem.length > 0) {
                item.OrcamentoItem.forEach(async (val) => {
                  const addItem = {
                    orcamentoCategoriaId: categId,
                    produtoId: val.produtoId,
                    descricao: val.produtoNome,
                    unidadeMedidaId: val.unidadeMedidaId,
                    quantidade: val.quantidade,
                    valorUn: val.valorUn,
                    valorTotal: val.valorTotal,
                  };
                  await axios.post(
                    process.env.REACT_APP_API_URL + "/orcamento/itens/",
                    addItem
                  );
                });
              }
            }
          });
        }
      }
      if (selectedMidias?.length > 0) {
        const removeMidia = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/midias/" + Number(id)
        );
        if (removeMidia.data === true) {
          selectedMidias.forEach(async (item) => {
            const addMidia = {
              orcamentoId: id,
              midiasId: item.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/midias/",
              addMidia
            );
          });
        }
      }
      if (selectedEntregaveis?.length > 0) {
        const remove = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/entregavel/" + Number(id)
        );
        if (remove.data === true) {
          selectedEntregaveis.forEach(async (item) => {
            const addEntregavel = {
              orcamentoId: id,
              entregavelId: item.entregavelId,
              quantidade: item.quantidade,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/entregavel/",
              addEntregavel
            );
          });
        }
      }
      setLoading(false);
      cancelSaveDraft();
      setTimeout(async () => {
        await loadOrder();
        await loadDraft();
      }, 1000);
    }

    setLoading(false);
    setLoadAprovacao(false);
    setShowAprovacao(false);
  };

  const save = async () => {
    if (validate()) {
      if (selectedDraft) {
        await insert();
      } else {
        if (selectedOrder) {
          await update();
        } else {
          await insert();
        }
      }
    }
  };

  const insert = async () => {
    setLoading(true);
    const addOrder = {
      acrescimo: Number(acrescimo),
      agenciaId: selectedAgency?.id ?? null,
      clientId: selectedClient?.id,
      comissao: Number(comissao),
      condicaoPagamentoId: selectedCondicaoPagamento?.id,
      contatoAgencia: contatoAgencia,
      contatoAgenciaEmail: emailAgencia,
      contatoAgenciaTelefone: telefoneAgencia,
      data: data,
      empresaSaiadaId: selectedFilial.id,
      desconto: desconto,
      descricao: descricao,
      carta: carta !== "" ? carta : footNotes[0]?.descricao,
      notaRodapeId: selectedFootNote?.id ?? null,
      notaRodapeTexto: notaRodape,
      contatoCliente: contatoCliente,
      contatoClienteEmail: emailCliente,
      contatoClienteTelefone: telefoneCliente,
      usuarioId: usuario.id,
      notas: notas,
      modeloNegocioId: selectedModeloNegocio.id,
      showAgencia: showAgenciaInput,
      idEmpresa: usuario.idEmpresa,
      status: status === "0" ? "1" : status,
      validade: validade,
      periodoVeiculacao: periodoVeiculacao,
      total: totalOrder,
      versao: 1,
      nome: nome,
      tipoDesconto: tipoDesconto,
      tipoComissao: tipoComissao,
      tipoAcrescimo: tipoAcrescimo,
      nomeVersao: nomeVersao,
      cadastroDescricaoId: cadastroDescricaoId,
    };

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/orcamento/",
      addOrder
    );
    if (response.data) {
      const id = response.data;
      if (itens?.length > 0) {
        itens.forEach(async (item) => {
          const addCategory = {
            orcamentoId: id,
            descricao: item.descricao,
            valor: item.valor,
          };
          const categ = await axios.post(
            process.env.REACT_APP_API_URL + "/orcamento/category/",
            addCategory
          );
          if (categ.data) {
            const categId = categ.data;
            if (item.OrcamentoItem.length > 0) {
              item.OrcamentoItem.forEach(async (val) => {
                const addItem = {
                  orcamentoCategoriaId: categId,
                  produtoId: val.produtoId,
                  descricao: val.produtoNome,
                  unidadeMedidaId: val.unidadeMedidaId,
                  quantidade: val.quantidade,
                  valorUn: val.valorUn,
                  valorTotal: val.valorTotal,
                };
                await axios.post(
                  process.env.REACT_APP_API_URL + "/orcamento/itens/",
                  addItem
                );
              });
            }
            if (item.OrcamentoProduto.length > 0) {
              item.OrcamentoProduto.forEach(async (val) => {
                const addProd = {
                  orcamentoCategoriaId: categId,
                  descricao: val.NovoProduto.nome,
                  novoProdutoId: val.novoProdutoId,
                  quantidade: val.quantidade,
                  valorUn: val.valorUn,
                  valorTotal: val.valorTotal,
                };
                await axios.post(
                  process.env.REACT_APP_API_URL + "/orcamento/produtos/",
                  addProd
                );
              });
            }
          }
        });
      }
      if (selectedMidias?.length > 0) {
        selectedMidias.forEach(async (item) => {
          const addMidia = {
            orcamentoId: id,
            midiasId: item.id,
          };
          await axios.post(process.env.REACT_APP_API_URL + "/orcamento/midias/", addMidia);
        });
      }
      if (selectedEntregaveis?.length > 0) {
        selectedEntregaveis.forEach(async (item) => {
          const addEntregavel = {
            orcamentoId: id,
            entregavelId: item.id,
            quantidade: item.quantidade,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/orcamento/entregavel/",
            addEntregavel
          );
        });
      }
      if (selectedDraft) {
        await axios.delete(
          process.env.REACT_APP_API_URL + "/rascunho-orcamento/" + selectedDraft?.id
        );
      }

      setLoading(false);
      cancelSaveDraft();
      setTimeout(async () => {
        await loadOrder();
        await loadDraft();
      }, 1000);
    }

    setLoading(false);
  };

  const update = async () => {
    setLoading(true);
    const updateOrder = {
      id: selectedOrder.id,
      acrescimo: Number(acrescimo),
      agenciaId: selectedAgency?.id ?? null,
      clientId: selectedClient?.id,
      comissao: Number(comissao),
      condicaoPagamentoId: selectedCondicaoPagamento?.id,
      contatoAgencia: contatoAgencia,
      contatoAgenciaEmail: emailAgencia,
      contatoAgenciaTelefone: telefoneAgencia,
      data: data,
      empresaSaiadaId: selectedFilial.id,
      desconto: desconto,
      descricao: descricao,
      carta: carta !== "" ? carta : footNotes[0]?.descricao,
      notaRodapeId: selectedFootNote?.id ?? null,
      notaRodapeTexto: notaRodape,
      contatoCliente: contatoCliente,
      contatoClienteEmail: emailCliente,
      contatoClienteTelefone: telefoneCliente,
      usuarioId: usuario.id,
      notas: notas,
      modeloNegocioId: selectedModeloNegocio.id,
      showAgencia: showAgenciaInput,
      idEmpresa: usuario.idEmpresa,
      status: status,
      validade: validade,
      periodoVeiculacao: periodoVeiculacao,
      total: totalOrder,
      versao: selectedOrder.versao + 1,
      nome: nome,
      tipoDesconto: tipoDesconto,
      tipoComissao: tipoComissao,
      tipoAcrescimo: tipoAcrescimo,
      nomeVersao: nomeVersao,
      cadastroDescricaoId: cadastroDescricaoId,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/orcamento/" + selectedOrder.id,
      updateOrder
    );
    if (response.data) {
      const id = selectedOrder.id;

      if (itens?.length > 0) {
        const removeCateg = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/category/" + Number(id)
        );
        if (removeCateg.data === true) {
          itens?.forEach(async (item) => {
            if (item.id !== "") {
              await axios.delete(
                process.env.REACT_APP_API_URL + "/orcamento/itens/" + item.id
              );
            }

            const addCategory = {
              orcamentoId: id,
              descricao: item.descricao,
              valor: item.valor,
            };
            const categ = await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/category/",
              addCategory
            );
            if (categ.data) {
              const categId = categ.data;
              if (item.OrcamentoItem.length > 0) {
                item.OrcamentoItem.forEach(async (val) => {
                  const addItem = {
                    orcamentoCategoriaId: categId,
                    produtoId: val.produtoId,
                    descricao: val.produtoNome,
                    unidadeMedidaId: val.unidadeMedidaId,
                    quantidade: val.quantidade,
                    valorUn: val.valorUn,
                    valorTotal: val.valorTotal,
                  };
                  await axios.post(
                    process.env.REACT_APP_API_URL + "/orcamento/itens/",
                    addItem
                  );
                });
              }
              if (item.OrcamentoProduto.length > 0) {
                item.OrcamentoProduto.forEach(async (val) => {
                  const addProd = {
                    orcamentoCategoriaId: categId,
                    descricao: val.NovoProduto.nome,
                    novoProdutoId: val.novoProdutoId,
                    quantidade: val.quantidade,
                    valorUn: val.valorUn,
                    valorTotal: val.valorTotal,
                  };
                  await axios.post(
                    process.env.REACT_APP_API_URL + "/orcamento/produtos/",
                    addProd
                  );
                });
              }
            }
          });
        }
      }
      if (selectedMidias?.length > 0) {
        const removeMidia = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/midias/" + Number(id)
        );
        if (removeMidia.data === true) {
          selectedMidias.forEach(async (item) => {
            const addMidia = {
              orcamentoId: id,
              midiasId: item.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/midias/",
              addMidia
            );
          });
        }
      }
      if (selectedEntregaveis?.length > 0) {
        const remove = await axios.delete(
          process.env.REACT_APP_API_URL + "/orcamento/entregavel/" + Number(id)
        );
        if (remove.data === true) {
          selectedEntregaveis.forEach(async (item) => {
            const addEntregavel = {
              orcamentoId: id,
              entregavelId: item.entregavelId,
              quantidade: item.quantidade,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/orcamento/entregavel/",
              addEntregavel
            );
          });
        }
      }
      setLoading(false);
      cancelSaveDraft();
      setTimeout(async () => {
        await loadOrder();
        await loadDraft();
      }, 1000);
    }

    setLoading(false);
  };

  const validate = () => {
    let retorno = true;

    if (nome === null || nome === "") {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo nome do projeto");
    }
    if (selectedFilial === null || selectedFilial === undefined) {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo Filial/Empresa Saída");
    }

    if (showAgenciaInput) {
      if (selectedAgency === null || selectedAgency === undefined) {
        retorno = false;
        showError("Erro!", "Preencha Corretamenete o Campo Agência");
      }
      if (contatoAgencia === null || contatoAgencia === undefined) {
        retorno = false;
        showError("Erro!", "Preencha Corretamenete o Campo Contato da Agência");
      }
      if (telefoneAgencia === null || telefoneAgencia === undefined) {
        retorno = false;
        showError(
          "Erro!",
          "Preencha Corretamenete o Campo Telefone de Contato da Agência"
        );
      }
      if (emailAgencia === null || emailAgencia === undefined) {
        retorno = false;
        showError(
          "Erro!",
          "Preencha Corretamenete o Campo Email de Contato da Agência"
        );
      }
    }

    if (contatoCliente === null || contatoCliente === undefined) {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo Contato da Cliente");
    }
    if (telefoneCliente === null || telefoneCliente === undefined) {
      retorno = false;
      showError(
        "Erro!",
        "Preencha Corretamenete o Campo Telefone de Contato da Cliente"
      );
    }
    if (emailCliente === null || emailCliente === undefined) {
      retorno = false;
      showError(
        "Erro!",
        "Preencha Corretamenete o Campo Email de Contato da Cliente"
      );
    }

    if (selectedModeloNegocio === null || selectedModeloNegocio === undefined) {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo Modelo de Negócio");
    }

    if (
      selectedCondicaoPagamento === null ||
      selectedCondicaoPagamento === undefined
    ) {
      retorno = false;
      showError(
        "Erro!",
        "Preencha Corretamenete o Campo Condição de Pagamento"
      );
    }
    // if (periodoVeiculacao === null || periodoVeiculacao === "") {
    //   retorno = false;
    //   showError(
    //     "Erro!",
    //     "Preencha Corretamenete o Campo Periodo de Veiculação"
    //   );
    // }
    if (notas === null || notas === "") {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo Notas de Versão");
    }

    if (selectedClient === null || selectedClient === undefined) {
      retorno = false;
      showError("Erro!", "Preencha Corretamenete o Campo Cliente");
    }

    return retorno;
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const calculaTotalOrder = (valor: number) => {
    setTotalOrder(valor);
  };

  const showCadastrarMidia = (show: boolean) => {
    setshowCadasdastrarMidiaModal(show);
  };

  const cadastrarMidia = async () => {
    const obj = {
      nome: midiaNomeRef.current,
      idEmpresa: usuario.idEmpresa,
      ativo: true,
    };
    const response = await axios.post(process.env.REACT_APP_API_URL + "/midia/", obj);
    if (response.data) {
      setLoading((prev) => (prev = false));
      showCadastrarMidia(false);
      midiaNomeRef.current = null;
      await loadMidias();
    }
  };

  const loadMidias = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/midia/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setMidias(response.data);
    }
  };

  const showCadastrarEntregavel = (show: boolean) => {
    setshowCadasdastrarEntregavelModal(show);
  };

  const loadFootNotes = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/nota-rodape/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setFootNotes(response.data);
      setSelectedFootNotes(response.data[0]);
    }
  };

  const loadEntregavel = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/entregavel/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setEntregavel(response.data);
    }
  };

  const cadastrarEntregavel = async () => {
    const obj = {
      nome: entregavelNomeRef.current,
      idEmpresa: usuario.idEmpresa,
      ativo: true,
    };
    const response = await axios.post(process.env.REACT_APP_API_URL + "/entregavel/", obj);
    if (response.data) {
      setLoading((prev) => (prev = false));
      showCadastrarEntregavel(false);
      entregavelNomeRef.current = null;
      await loadEntregavel();
    }
  };
  const reorder = (
    list: OrderCategory[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    setItens(result);
  };

  const loadDraft = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/rascunho-orcamento/list/" + userData?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setListDraft(response.data);
    }
  };

  const { descricoes } = useDescription();

  const reloadDataClients = async () => {
    await loadAgency();
    await loadClient();

    if (selectedClient) {
      const newItem = clients.find((item) => item.id === selectedClient.id);
      onChangeClient(newItem.id);
    }
  };

  const addRowItem = (item: OrderItemProduct, categ: OrderCategory) => {
    const itens = [...itemList];
    const existe = itens.find((a) => a.novoProdutoId === item.novoProdutoId);
    if (existe) {
      showError("Erro!", "Produto já existe na lista");
    } else {
      itens.push(item);
    }
    setItemList(itens);

    categ.OrcamentoProduto = itens;
    changeItem(categ);
  };

  const deleteRow = (item: OrderItemProduct, categ: OrderCategory) => {
    const newList = itemList.filter((dt) => dt !== item);
    setItemList(newList);
    categ.OrcamentoProduto = newList;
    changeItem(categ);
  };

  const editRow = (item: OrderItemProduct, categ: OrderCategory) => {
    const newItems: OrderItemProduct[] = categ?.OrcamentoProduto?.map(
      (existingItem) => {
        if (existingItem.novoProdutoId === item.novoProdutoId) {
          return item;
        }
        return existingItem;
      }
    );
    setItemList(newItems);
    categ.OrcamentoProduto = newItems;
    changeItem(categ);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          loadOrder(),
          loadClient(),
          loadAgency(),
          loadCondicaoPagamento(),
          loadModeloNegocio(),
          loadEmpresas(),
          loadMidias(),
          loadEntregavel(),
          loadFootNotes(),
          loadDraft(),
        ]);
      } catch (error) {
        // Handle errors if needed
        console.error("Error while loading data:", error);
      }
    };

    loadData();
  }, []);

  return {
    add,
    show,
    showPrint,
    error,
    errorTitle,
    errorMsg,
    showDelete,
    list,
    selectedClient,
    selectedOrder,
    selectedAgency,
    usuario,
    loading,
    clients,
    closeDelete,
    showDeleteModal,
    showPrintModal,
    showModal,
    cancelRef,
    remove,
    edit,
    save,
    deletar,
    onChangeClient,
    closeError,
    print,
    agency,
    totalOrder,
    totalItens,
    calculaTotalOrder,
    onChangeAgency,
    itens,
    showItem,
    nomeRef,
    showItemModal,
    removeItem,
    changeItem,
    saveCategory,

    contatoCliente,
    emailCliente,
    telefoneCliente,
    listContatoCliente,
    contatoAgencia,
    emailAgencia,
    telefoneAgencia,
    listContatoAgencia,
    changeInput,
    showAgenciaInput,
    showAgenciaInputModal,
    condicaoPagamento,
    modeloNegocio,
    selectedModeloNegocio,
    selectedCondicaoPagamento,
    onChangePagamento,
    onChangeModeloNegocio,
    filiais,
    selectedFilial,
    onChangeFilial,
    entregavel,
    selectedEntregaveis,
    onChangeEntregavel,
    midias,
    selectedMidias,
    onChangeMidias,
    data,
    validade,
    showCadasdastrarMidiaModal,
    midiaNomeRef,
    cadastrarMidia,
    showCadastrarMidia,
    showMidiaRef,
    showCadasdastrarEntregavelModal,
    entregavelNomeRef,
    cadastrarEntregavel,
    showCadastrarEntregavel,
    showEntregavelaRef,
    reorder,
    enableDrag,
    isDragable,
    carta,
    changeCarta,
    nome,
    descricao,
    exportExcel,
    filteredClients,
    filteredAgency,
    changeFootNotes,
    footNotes,
    selectedFootNote,
    desconto,
    acrescimo,
    comissao,
    totalCalculado,
    tipoAcrescimo,
    tipoComissao,
    tipoDesconto,
    templateList,
    onChangeTemplate,
    showRascunho,
    showDraft,
    cancelRascunho,
    cancelSaveDraft,
    saveDraft,
    loadingDraft,
    listDraft,
    editDraft,
    deleteDraft,
    removeDraft,
    selectedDraft,
    nomeVersao,
    descricoes,
    changeCadastroDescricao,
    selectedCadastro,
    showContatoModal,
    showContactModal,
    editContact,
    saveContact,
    selectedContact,
    changeType,
    type,
    loadAgency,
    loadClient,
    showError,
    reloadDataClients,
    cancelAprovacao,
    showAprovacao,
    showAprovacaoModal,
    loadprovacao,
    saveAprovacao,
    itemList,
    addRowItem,
    editRow,
    deleteRow,
  };
};

export default useOrder;
